<template>
    <v-row align="center">
        <v-col>
            <v-text-field :label="label" v-model="phone1" v-bind="inputProps" />
        </v-col>
        -
        <v-col>
            <v-text-field v-model="phone2" v-bind="inputProps" />
        </v-col>
        -
        <v-col>
            <v-text-field v-model="phone3" v-bind="inputProps" />
        </v-col>
    </v-row>
</template>

<script>
const inputProps = {
    outlined: true,
    dense: true,
    "hide-details": true,
    persistentPlaceholder: true,
    class: "rounded-0",
};

export default {
    props: ["value", "label"],
    computed: {
        phone() {
            return [this.phone1, this.phone2, this.phone3].join("-");
        },
    },
    data() {
        return {
            phone1: null,
            phone2: null,
            phone3: null,
            inputProps,
        };
    },
    methods: {
        init() {
            [this.phone1, this.phone2, this.phone3] = this.value.split("-");
        },
        sync() {
            this.$emit("input", this.phone);
        },
    },
    mounted() {
        if (this.value) this.init();
    },
    watch: {
        value() {
            if (this.value !== this.phone) this.init();
        },
        phone() {
            if (this.value !== this.phone) this.sync();
        },
    },
};
</script>

<style></style>
